import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authStore } from '@/stores/authStore';

export const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const token = searchParams.get('token');
        if (!token) {
          console.error('No token received');
          await new Promise(resolve => setTimeout(resolve, 100));
          navigate('/login');
          return;
        }

        // Set the token first
        authStore.setTokens(token);

        // Then fetch user data
        await authStore.fetchUserData();
        
        // Only navigate after successful user data fetch
        navigate('/dashboard');
      } catch (error) {
        console.error('Auth callback error:', error);
        await authStore.logout();
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return <div>Loading...</div>;
};

export default AuthCallback; 